import {action, makeObservable} from "mobx";
import {requests} from "../api";
import {Ioc} from "../models/ioc";

declare var defaultToken: any

export class IocStore {
    code = ""
    data: Ioc[] = []
    ioc?: string

    constructor() {
        makeObservable(this)
        let code
        if (!code) {
            try {
                code = localStorage.getItem('auth_code')!
            } catch (e) {}
        }
        this.code = defaultToken || code
    }

    @action
    setIoc = (ioc: string) => {
        this.ioc = ioc
    }

    @action
    setCode = (code: string) => {
        this.code = code
    }

    @action
    clear = () => {
        this.data = []
    }

    @action
    loadData = async (ioc?: string) => {
        if (!ioc) {
            ioc = this.ioc
        } else {
            this.ioc = ioc
        }

        if (this.data.length && this.data.filter(v => v.ioc === ioc).length) {
            return
        }

        const data = await requests.get(
            '/user/check_ioc/' + ioc,
            {Authorization: this.code}
        )

        this.data.push(new Ioc(data))

        return
    }
}